import * as React from "react";
import useSWR, { mutate } from "swr";
import { useActiveInfluencerWithSetter } from "../services/ActiveInfluencer";
import fetcher from "./fetcher";

const buildKey = (route) =>
  route
    ? `/api/influencer?dashboard=true&route=${encodeURIComponent(route)}`
    : null;

export default function useDashboardInfluencer(route) {
  const { data, error, mutate: refresh } = useSWR(buildKey(route), fetcher);
  const { setActiveInfluencer } = useActiveInfluencerWithSetter();

  React.useEffect(() => {
    if (data) setActiveInfluencer(data);
  }, [data, setActiveInfluencer]);

  return {
    isLoading: !data && !error,
    isError: Boolean(error),
    error,
    refresh,
  };
}

export const mutateDashboardInfluencer = (route) => mutate(buildKey(route));
